/* ==========================================================================
   IGNITON × YOGA INTERNATIONAL — Partnership Landing Page JS
   GSAP scroll animations, countdown, discount auto-apply, ATC, marquee
   ========================================================================== */

(function () {
  'use strict';

  /* ── Constants ── */
  const DISCOUNT_CODE = window.ypDiscountCode || 'YOGA25';
  const DEADLINE = window.ypOfferDeadline || '2026-03-31T23:59:59';

  /* ==========================================================================
     1. AUTO-APPLY DISCOUNT CODE VIA URL
     ========================================================================== */
  function autoApplyDiscount() {
    var params = new URLSearchParams(window.location.search);
    var code = params.get('discount') || params.get('discount_code');

    if (code) {
      /* Shopify auto-applies discount when added to checkout URL.
         Store it in sessionStorage so the ATC handler can use it. */
      sessionStorage.setItem('yp_discount_code', code);

      /* Show "Applied" badge */
      var appliedBadge = document.querySelector('.yp-promo-banner__applied');
      if (appliedBadge) {
        appliedBadge.style.display = 'inline';
      }
    }
  }

  /* ==========================================================================
     2. COPY DISCOUNT CODE
     ========================================================================== */
  function initCopyCode() {
    var codeBtn = document.querySelector('.yp-promo-banner__code');
    if (!codeBtn) return;

    codeBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(DISCOUNT_CODE).then(function () {
        var original = codeBtn.textContent;
        codeBtn.textContent = 'Copied!';
        setTimeout(function () {
          codeBtn.innerHTML = DISCOUNT_CODE + ' <span class="yp-promo-banner__code-icon" aria-hidden="true">⎘</span>';
        }, 1500);
      });
    });
  }

  /* ==========================================================================
     3. COUNTDOWN TIMER
     ========================================================================== */
  function initCountdown() {
    var deadlineDate = new Date(DEADLINE).getTime();
    var daysEl = document.getElementById('yp-cd-days');
    var hoursEl = document.getElementById('yp-cd-hours');
    var minsEl = document.getElementById('yp-cd-mins');
    var secsEl = document.getElementById('yp-cd-secs');

    if (!daysEl) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, deadlineDate - now);

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = pad(d);
      hoursEl.textContent = pad(h);
      minsEl.textContent = pad(m);
      secsEl.textContent = pad(s);

      if (diff > 0) {
        setTimeout(tick, 1000);
      }
    }

    tick();
  }

  /* ==========================================================================
     4. PRICING TABS & VARIANT SELECTION
     ========================================================================== */
  function initPricing() {
    /* Scope each offer section independently so multiple instances work */
    document.querySelectorAll('.yp-offer').forEach(function (section) {
      var tabs = section.querySelectorAll('.yp-pricing-tab');
      var pricingEls = section.querySelectorAll('[data-yp-pricing]');
      var priceCurrentEl = section.querySelector('.yp-price-current');
      var priceCompareEl = section.querySelector('.yp-price-compare');
      var priceSaveEl = section.querySelector('.yp-price-save');
      var atcBtn = section.querySelector('.yp-product-card__atc');

      if (!tabs.length) return;

      /* Tab switching */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = this.dataset.tab;

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          pricingEls.forEach(function (el) {
            el.style.display = el.dataset.ypPricing === target ? '' : 'none';
          });

          /* Swap discount code display for one-time vs subscribe */
          if (atcBtn) {
            var code = target === 'subscribe'
              ? (atcBtn.dataset.subCode || atcBtn.dataset.onetimeCode)
              : atcBtn.dataset.onetimeCode;
            var codeEl = atcBtn.querySelector('.yp-atc-code');
            if (codeEl && code) codeEl.textContent = code;
            var priceCodeEl = section.querySelector('.yp-price-code-display');
            if (priceCodeEl && code) priceCodeEl.textContent = code;
          }

          /* Select first option in new panel */
          var visiblePanel = section.querySelector('.yp-variant-select[data-yp-pricing="' + target + '"]');
          if (visiblePanel) {
            var firstOpt = visiblePanel.querySelector('.yp-variant-option');
            if (firstOpt) firstOpt.click();
          }
        });
      });

      /* Variant option selection */
      section.querySelectorAll('.yp-variant-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var parent = this.closest('.yp-variant-select');
          parent.querySelectorAll('.yp-variant-option').forEach(function (o) {
            o.classList.remove('is-active');
          });
          this.classList.add('is-active');

          /* Update price display */
          var price = this.dataset.price;
          var compare = this.dataset.comparePrice;
          var save = this.dataset.save;
          var variantId = this.dataset.variantId;

          if (priceCurrentEl && price) priceCurrentEl.textContent = '$' + price;
          if (priceCompareEl && compare) priceCompareEl.textContent = '$' + compare;
          if (priceSaveEl && save) priceSaveEl.textContent = 'Save $' + save;
          if (atcBtn && variantId) atcBtn.dataset.variantId = variantId;
        });
      });
    });
  }

  /* ==========================================================================
     5. ADD TO CART
     ========================================================================== */
  function initAddToCart() {
    document.querySelectorAll('.yp-product-card__atc').forEach(function (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        if (!variantId) return;

        this.classList.add('is-loading');
        this.disabled = true;
        var btn = this;

        var body = JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            /* Apply discount code via Shopify's /discount/ route, then redirect to cart */
            var code = btn.closest('.yp-offer')
              ? (btn.dataset.subCode && btn.closest('.yp-offer').querySelector('.yp-pricing-tab[data-tab="subscribe"].is-active')
                ? btn.dataset.subCode
                : btn.dataset.onetimeCode)
              : DISCOUNT_CODE;
            if (code) {
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
            var label = btn.querySelector('.yp-atc-label');
            if (label) label.textContent = 'Error — try again';
          });
      });
    });
  }

  /* ==========================================================================
     6. MOBILE STICKY BAR
     ========================================================================== */
  function initStickyBar() {
    var bar = document.querySelector('.yp-sticky-bar');
    var barBtn = bar ? bar.querySelector('.yp-sticky-bar__btn') : null;

    if (!bar) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset || document.documentElement.scrollTop;
          bar.classList.toggle('is-visible', scrollY > 600);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var offerSection = document.querySelector('.yp-offer');
        if (offerSection) {
          offerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* ==========================================================================
     7. TESTIMONIAL MARQUEE — clone cards for infinite loop
     ========================================================================== */
  function initMarquee() {
    var track = document.querySelector('.yp-testimonials__track');
    if (!track) return;

    var cards = track.querySelectorAll('.yp-review-card');
    /* Clone all cards and append for seamless loop */
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  /* ==========================================================================
     8. PARTICLE CANVAS — subtle floating dots on hero right
     ========================================================================== */
  function initParticles() {
    var canvas = document.getElementById('yp-particle-canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var particles = [];
    var particleCount = 40;

    function resize() {
      var rect = canvas.parentElement.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
    }

    function createParticle() {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        r: Math.random() * 2 + 0.5,
        alpha: Math.random() * 0.3 + 0.1
      };
    }

    function init() {
      resize();
      particles = [];
      for (var i = 0; i < particleCount; i++) {
        particles.push(createParticle());
      }
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(211, 162, 60, ' + p.alpha + ')';
        ctx.fill();
      });

      /* Draw connections between close particles */
      for (var i = 0; i < particles.length; i++) {
        for (var j = i + 1; j < particles.length; j++) {
          var dx = particles[i].x - particles[j].x;
          var dy = particles[i].y - particles[j].y;
          var dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = 'rgba(211, 162, 60, ' + (0.06 * (1 - dist / 120)) + ')';
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(draw);
    }

    init();
    draw();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 200);
    });
  }

  /* ==========================================================================
     9. GSAP SCROLL ANIMATIONS
     ========================================================================== */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      /* Fallback: just show everything if GSAP fails to load */
      document.querySelectorAll('[data-yp-reveal]').forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    /* Reveal animations */
    document.querySelectorAll('[data-yp-reveal]').forEach(function (el) {
      var delay = parseFloat(el.dataset.ypDelay) * 0.15 || 0;
      var direction = el.dataset.ypReveal;

      var fromVars = { opacity: 0, duration: 0.8, delay: delay, ease: 'power2.out' };

      if (direction === 'left') {
        fromVars.x = -40;
      } else if (direction === 'right') {
        fromVars.x = 40;
      } else {
        fromVars.y = 30;
      }

      gsap.from(el, Object.assign({}, fromVars, {
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        }
      }));
    });

    /* Hero headline word stagger */
    var words = document.querySelectorAll('.yp-hero__headline .word');
    if (words.length) {
      gsap.from(words, {
        opacity: 0,
        y: 20,
        duration: 0.6,
        stagger: 0.08,
        ease: 'power2.out',
        delay: 0.3
      });
    }

    /* Counter animation for stats */
    document.querySelectorAll('[data-yp-count]').forEach(function (el) {
      var target = parseInt(el.dataset.ypCount, 10);

      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to({ val: 0 }, {
            val: target,
            duration: 2,
            ease: 'power2.out',
            onUpdate: function () {
              el.textContent = Math.round(this.targets()[0].val);
            }
          });
        }
      });
    });

    /* Product float gentle bob */
    var productFloat = document.querySelector('.yp-hero__product-float');
    if (productFloat) {
      gsap.to(productFloat, {
        y: -10,
        duration: 3,
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1
      });
    }
  }

  /* ==========================================================================
     INIT — Run everything on DOM ready
     ========================================================================== */
  function init() {
    autoApplyDiscount();
    initCopyCode();
    initCountdown();
    initPricing();
    initAddToCart();
    initStickyBar();
    initMarquee();
    initParticles();

    /* GSAP might load async (defer), so wait a tick */
    if (typeof gsap !== 'undefined') {
      initGSAP();
    } else {
      /* Wait for GSAP to load */
      var checkGSAP = setInterval(function () {
        if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
          clearInterval(checkGSAP);
          initGSAP();
        }
      }, 100);

      /* Give up after 5 seconds */
      setTimeout(function () {
        clearInterval(checkGSAP);
        if (typeof gsap === 'undefined') {
          initGSAP(); /* Will trigger fallback */
        }
      }, 5000);
    }
  }

  /* Guard against double-init if loaded by multiple sections */
  if (window.__ypInitDone) return;
  window.__ypInitDone = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
